<template>
  <article>
    <AppBanner title="Contact Us">
      <div class="flex-col flex items-center justify-center">
        <p class="w-full max-w-3xl">
          We're here to help — Reach out to us anytime via the form below or through our contact details,
          and we'll get back to you as soon as possible.
        </p>

        <IconEmailLink />
      </div>
    </AppBanner>

    <!-- Contact Form -->
    <AppSection>
      <AppSectionHeading class="max-w-lg">
        <p class="text-center text-primary">
          Please complete the form below, and our team will reach out to you promptly.
        </p>
      </AppSectionHeading>

      <AppContainer>
        <Transition
          name="scale-fade-out"
          appear
        >
          <div class="grid grid-cols-12 rounded-lg overflow-hidden mb-6">
            <div class="col-span-12 md:col-span-4 xs:hidden md:block">
              <img
                loading="lazy"
                src="@/assets/images/views/contact-us/form.webp"
                alt="contact form image"
                class="block w-full h-60 md:h-full object-cover"
                style="object-position: 50% 10%;"
              >
            </div>

            <div class="col-span-12 md:col-span-8 bg-primary py-6 container-padding">
              <ContactForm @submit="showThankYouModal = true" />
            </div>
          </div>
        </Transition>
      </AppContainer>
    </AppSection>

    <!-- Contact Form -->
    <AppContainer class="max-w-3xl text-center text-lg md:text-xl mb-14">
      <div class="flex gap-3 justify-center mb-6">
        <FontAwesomeIcon
          :icon="faPersonRunningFast"
          class="text-primary text-3xl h-[1em] w-[1em]"
        />

        <FontAwesomeIcon
          :icon="faBicycle"
          class="text-primary text-3xl h-[1em] w-[1em]"
        />

        <FontAwesomeIcon
          :icon="faPersonSwimming"
          class="text-primary text-3xl h-[1em] w-[1em]"
        />
      </div>

      <div class="font-semibold text-base md:text-xl w-full max-w-3xl mx-auto">
        <p class="text-black mb-1">
          Our vision is to be a national service provider for Action Sports, where photos are categorised accordingly
          and
          easily accessed, viewed & ordered.
        </p>

        <p class="text-secondary">
          We invest a lot of time & resources, partner with professionals, and are driven to be the best in this field.
        </p>
      </div>
    </AppContainer>

    <Transition name="fade">
      <AppModal
        v-if="showThankYouModal"
        class="thank-you-modal"
        size="lg"
        @close="showThankYouModal = false"
      >
        <h2 class="mb-2">
          Thank You
        </h2>

        <p class="text-secondary mb-6">
          Your details have been successfully submitted.
        </p>

        <p class="mb-6">
          We are processing your information and will get back to you shortly. If you have any questions in the
          meantime, please feel free to contact us.
        </p>

        <AppButton
          class="btn-outline btn-secondary w-full"
          @click="showThankYouModal = false"
        >
          Ok
        </AppButton>
      </AppModal>
    </Transition>
  </article>
</template>

<script setup>
import { ref } from 'vue';
import { AppBanner, AppButton, AppContainer, AppModal, AppSection, AppSectionHeading } from '@/components/app';

import { ContactForm } from '@/components/forms';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faBicycle, faPersonRunningFast, faPersonSwimming } from '@fortawesome/sharp-solid-svg-icons';

import { IconEmailLink } from '@/components/links';

const showThankYouModal = ref(false);

</script>
